import React from "react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "./ui/alert-dialog";

export default function ConfirmDialog({ open, onOpenChange, title, description, onConfirm, confirmText = "EVET, SİL" }) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="border-slate-700 bg-slate-900 text-slate-100">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-head">{title || "EMİN MİSİNİZ?"}</AlertDialogTitle>
          <AlertDialogDescription className="text-slate-400">
            {description || "BU İŞLEM GERİ ALINAMAZ."}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="confirm-cancel" className="border-slate-700 bg-slate-800 text-slate-200 hover:bg-slate-700">
            VAZGEÇ
          </AlertDialogCancel>
          <AlertDialogAction
            data-testid="confirm-ok"
            onClick={onConfirm}
            className="bg-rose-600 text-white hover:bg-rose-700"
          >
            {confirmText}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
